import React, { useState } from "react";
import { Col, Dropdown, Stack, Row, Container, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import ProductItem from "../components/ProductItem";
import { useNavigate } from "react-router-dom";
import ProductCardSkeleton from "../components/skeletons/ProductCard";
import {
  fetchLiquorStoreCatalog,
  fetchStoreInfo,
} from "../lib/webService/webService";
import { Seo } from "../components/Seo";
import { Breadcrumb } from "../components/Breadcrumb";
import { generateLiquorCategorySEO, generateNoIndexSEO } from "../lib/seo/metaGenerators";

function ShowSkeleton() {
  const skeletons = [];
  for (var i = 0; i < 24; i++) {
    skeletons.push(
      <Col key={i} className="my-2">
        <ProductCardSkeleton />
      </Col>
    );
  }

  return skeletons;
}

const LiquorStoreProducts = () => {
  const { storeId, type, subType } = useParams();
  const [storeInfo, setStoreInfo] = useState({});
  const [catalog, setCatalog] = useState([]);
  const [storeInfoLoading, setStoreInfoLoading] = useState(true);
  const [isCatalogLoading, setIsCatalogLoading] = useState(true);
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchStoreInfo(storeId).then((store) => {
      setStoreInfo(store);
      setStoreInfoLoading(false);
    });
    fetchLiquorStoreCatalog(storeId, type, subType).then((catalogData) => {
      setCatalog(catalogData);
      setIsCatalogLoading(false);
    });
  }, []);

  const handleRollback = () => {
    navigate(-1);
  };

  const arrowLeftStyles = {
    cursor: hover ? "pointer" : "auto",
    transition: "transform 0.2s ease-in-out",
    transform: hover ? "scale(1.1)" : "scale(1)",
  };

  const seo = !storeInfoLoading && storeInfo.store_name
    ? generateLiquorCategorySEO(storeId, storeInfo.store_name, type, subType)
    : generateNoIndexSEO("Liquor Store");

  return (
    <Container className="py-4">
      <Seo {...seo} />
      {!storeInfoLoading && <Breadcrumb items={seo.breadcrumbItems} />}
      <Stack gap={4}>
        <div className="d-flex align-items-center bg-light p-3 rounded-3 shadow-sm">
          <div className="p-2">
            <svg
              onClick={handleRollback}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={arrowLeftStyles}
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              fill="currentColor"
              className="bi bi-arrow-left-short"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
              />
            </svg>
          </div>
          <div className="ms-2">
            {storeInfoLoading ? (
              <div className="d-flex align-items-center">
                <Spinner animation="border" size="sm" className="me-2" />
                <span className="text-muted">Loading store info...</span>
              </div>
            ) : (
              <>
                <h2 className="fs-4 fw-bold mb-1">{storeInfo.name}</h2>
                {storeInfo.address && (
                  <p className="text-muted mb-0 small">{storeInfo.address}</p>
                )}
              </>
            )}
          </div>
        </div>

        <div>
          {isCatalogLoading ? (
            <Row xs={1} sm={2} md={3} lg={4} className="g-3">
              <ShowSkeleton />
            </Row>
          ) : catalog.length === 0 ? (
            <div className="text-center py-5">
              <h3 className="text-muted">No products found</h3>
              <p className="text-muted">This store doesn't have any products in this category yet.</p>
            </div>
          ) : (
            <Row xs={1} sm={2} md={3} lg={4} className="g-3">
              {catalog.map((product) => (
                <Col key={product.id}>
                  <ProductItem {...product} />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Stack>
    </Container>
  );
};

export default LiquorStoreProducts;
